import React from 'react';
import { IonIcon } from '@ionic/react';
import Modal from '../../components/modal';
import { Title, StrongText, SmallText, Spacer } from '../../components/common';
import { withTranslation } from '../../lib/translate';
import './index.css';
import { informationCircleOutline, checkmarkCircle, checkmark, checkmarkOutline, chevronForward, lockClosed, gift } from 'ionicons/icons';
import { getConfig } from '../../appConfig';
import { forwardTo } from '../../lib/utils';

class DashboardRewards extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}


	getMilestoneRewardsData = (rewards, balance) => {
		if (!Array.isArray(rewards) || rewards.length === 0) {
			return { rewards: [], nextRewardPoints: 0 };
		}

		const sorted = [...rewards].sort((a, b) => a.stamps_required - b.stamps_required);
		const lastThreshold = sorted[sorted.length - 1].stamps_required;

		if (balance >= lastThreshold) {
			const finalList = sorted.map((item, index) => {
				const prev = index === 0 ? 0 : sorted[index - 1].stamps_required;
				const segmentSize = item.stamps_required - prev;

				return {
					...item,
					percentageFilled: '100%',
					percentage: `${((segmentSize / lastThreshold) * 100).toFixed(2)}%`,
					earned: true,
				};
			});

			return { rewards: finalList, nextRewardPoints: 0 };
		}

		let prevThreshold = 0;
		let foundNext = false;
		let nextRewardPoints = 0;

		const processed = sorted.map((item) => {
			const currentThreshold = item.stamps_required;
			const segmentSize = currentThreshold - prevThreshold;

			let filledPercent;
			if (balance >= currentThreshold) {
				filledPercent = 100;
			} else if (balance <= prevThreshold) {
				filledPercent = 0;
			} else {
				const inside = balance - prevThreshold;
				filledPercent = +(inside / segmentSize * 100).toFixed(2);
			}

			if (!foundNext && balance < currentThreshold) {
				nextRewardPoints = currentThreshold - balance;
				foundNext = true;
			}

			const percentageOfTotal = +((segmentSize / lastThreshold) * 100).toFixed(2);
			const earned = balance >= currentThreshold;

			prevThreshold = currentThreshold;

			return {
				...item,
				percentageFilled: `${Math.floor(filledPercent)}%`,
				percentage: `${percentageOfTotal}%`,
				earned,
			};
		});

		return { rewards: processed, nextRewardPoints };
	};

	render() {
		const { __, milestoneInfo, available_points, unlockRewardsInfo, unlockRewards, milestoneRewards } = this.props;
		const { rewards, nextRewardPoints } = this.getMilestoneRewardsData(this.props.rewards, available_points);
		const earnedRewards = rewards.filter(r => r.earned);
		const nextReward = rewards.find(r => !r.earned);
		const nextRewardName = nextReward?.name || null;
		const bannerReward = nextReward || earnedRewards[earnedRewards.length - 1] || null;
		const maxProgressBarLength = parseInt(getConfig().general?.rewardsProgressBarMaximumLength, 10) || 0;
		const allDisplayRewards = nextReward ? [...earnedRewards, nextReward] : earnedRewards;
		const displayRewards = maxProgressBarLength ? allDisplayRewards.slice(-maxProgressBarLength) : allDisplayRewards;
		const totalPct = displayRewards.reduce((sum, r) => sum + parseFloat(r.percentage), 0);
		const scaledRewards = displayRewards.map(r => ({
			...r,
			percentage: totalPct > 0 ? `${(parseFloat(r.percentage) / totalPct * 100).toFixed(2)}%` : r.percentage,
		}));
		return (
			<>
				<div className='dashboard-reward-wrapper box-wrapper'>
					<div className='dashboard-reward-header' style={{ alignItems: 'center', border: 'none', paddingBottom: '0' }}>
						<div>
							<SmallText className='reward-color-text is-uppercase'>{__('LOYALTY REWARDS')}</SmallText>
							<Spacer size={0} />
							<div style={{ display: 'flex', gap: '5px', alignItems: 'baseline' }}>
								<Title style={{ lineHeight: '1' }} className={'reward-color-text-dark dashboard-reward-header-title no-decorator'}>{available_points}</Title>
								<StrongText className='reward-color-text bold' style={{ lineHeight: '1' }}>{available_points == 1 ? __('pt') : __('pts')}</StrongText>
							</div>
						</div>
						{nextRewardPoints > 0 ?
							<div style={{ display: 'grid', justifyItems: 'flex-end' }}>
								<StrongText>{__(nextRewardPoints == 1 ? '{points} pt to' : '{points} pts to', { points: nextRewardPoints })}</StrongText>
								<StrongText className='reward-color-text-dark'>{nextRewardName}</StrongText>
							</div>
							:
							<div className='dashboard-rewards-unlocked'>
								<SmallText className='bold reward-color-text-dark'>{__('MAX · all unlocked')}</SmallText>
							</div>

						}


					</div>
					<div className='dashboard-reward-progress-wrapper'>
						<div className='dashboard-reward-progress-bar'>
							{scaledRewards.map((el, rewardIndex) => (
								<div key={`reward_${rewardIndex}`} style={{ flex: 1 }}>
									<div style={{ display: 'grid', gridAutoFlow: 'column', alignItems: 'center', justifyContent: 'flex-end', gap: '5px' }}>

										<SmallText className={`bold dashboard-reward-bar-label ${el.earned ? 'reward-color-text-dark' : ''}`}>{el.stamps_required}</SmallText>
										<div className={`dashboard-reward-bar-icon ${!el.earned ? 'dashboard-reward-bar-icon-locked' : ''}`}
										>
											<IonIcon
												icon={el.earned ? checkmarkOutline : lockClosed}
											/>
										</div>
									</div>
									<div className='dashboard-reward-bar-track' data-percentagefilled={el.percentageFilled}>
										<span style={{ width: el.percentageFilled }}></span>
									</div>

									<SmallText className='dashboard-reward-bar-label-small dashboard-reward-bar-label reward-color-text'>{el.name}</SmallText>
								</div>
							))}
						</div>
					</div>
					{/* This banner is the component's only route to /loyalty. Gating it on
					    unlockRewards alone left milestone-only clients with a progress bar
					    and nothing clickable - the milestoneRewards prop was destructured
					    and then never used. Config cannot work around it: enabling
					    hasUnlockRewards renders a second, points-based panel off
					    available_balance, which reads 0 when points are switched off. */}
					{(unlockRewards || milestoneRewards) &&
						<>
							{bannerReward && (
								<div className='dashboard-next-reward-banner' onClick={() => forwardTo('/loyalty', { scrollToUnlockRewards: true })}>
									{bannerReward.reward?.additional_config?.icon ?
										<img src={bannerReward.reward.additional_config.icon} />
										:
										<IonIcon icon={gift} />
									}
									<div>
										{nextRewardPoints > 0 ?
											<SmallText className='block bold reward-color-text-dark'>{__(nextRewardPoints == 1 ? '{points} pt to {name}' : '{points} pts to {name}', { points: nextRewardPoints, name: bannerReward.name })}</SmallText>
											: <SmallText className='block bold reward-color-text-dark'>{__(bannerReward.stamps_required == 1 ? 'Redeem {stamps} point for {name}' : 'Redeem {stamps} points for {name}', { stamps: bannerReward.stamps_required, name: bannerReward.name })}</SmallText>

										}
										{nextRewardPoints > 0
											? <SmallText style={{ lineHeight: 1.1 }} className='bold reward-color-text'>{__('View rewards & redeem')}</SmallText>
											: <SmallText style={{ lineHeight: 1.1 }} className='bold reward-color-text'>{__("You've unlocked every reward")}</SmallText>
										}
									</div>
									<IonIcon icon={chevronForward} />
								</div>
							)}
						</>

					}
				</div>

			</>
		);
	}
}



export default withTranslation(DashboardRewards);
